import React, { useState } from 'react';
import { PrimaryButtonPurple, PrimaryButtonGreen, SecondaryButtonOutline } from '../ui/Buttons';
import { AlignLeft, AlignCenter, AlignRight, Eye, Lock, Trash2 } from 'lucide-react';
export function TextPanel() {
  const [hasText, setHasText] = useState(false);
  const [outline, setOutline] = useState(false);
  const [outlineWidth, setOutlineWidth] = useState(2);
  return <div className="h-full flex flex-col" data-id="element-150">
      <div className="p-4 border-b border-gray-100" data-id="element-151">
        <h2 className="font-semibold text-gray-900" data-id="element-152">Text</h2>
      </div>

      <div className="p-4 space-y-6 overflow-y-auto flex-1" data-id="element-153">
        {!hasText ? <PrimaryButtonPurple className="w-full" onClick={() => setHasText(true)} data-id="element-154">
            Add text
          </PrimaryButtonPurple> : <div className="space-y-4" data-id="element-155">
            <input type="text" defaultValue="Your Text Here" className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:ring-2 focus:ring-violet-500 outline-none" data-id="element-156" />

            <div className="grid grid-cols-2 gap-2" data-id="element-157">
              <select className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm" data-id="element-158">
                <option data-id="element-159">Inter</option>
                <option data-id="element-160">Roboto</option>
                <option data-id="element-161">Lobster</option>
              </select>
              <input type="number" defaultValue={48} className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm" data-id="element-162" />
            </div>

            <div className="flex items-center gap-2" data-id="element-163">
              <div className="w-8 h-8 rounded border border-gray-200 bg-black cursor-pointer" data-id="element-164" />
              <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-165">
                <button className="p-2 hover:bg-gray-50 border-r border-gray-200" data-id="element-166">
                  <AlignLeft size={16} data-id="element-167" />
                </button>
                <button className="p-2 hover:bg-gray-50 border-r border-gray-200 bg-gray-50" data-id="element-168">
                  <AlignCenter size={16} data-id="element-169" />
                </button>
                <button className="p-2 hover:bg-gray-50" data-id="element-170">
                  <AlignRight size={16} data-id="element-171" />
                </button>
              </div>
            </div>

            <div className="border-t border-gray-100 pt-4" data-id="element-172">
              <div className="flex items-center justify-between mb-2" data-id="element-173">
                <span className="text-sm font-medium text-gray-700" data-id="element-174">
                  Outline
                </span>
                <button onClick={() => setOutline(!outline)} className={`w-11 h-6 rounded-full transition-colors relative ${outline ? 'bg-violet-600' : 'bg-gray-200'}`} data-id="element-175">
                  <div className={`w-4 h-4 bg-white rounded-full absolute top-1 transition-transform ${outline ? 'left-6' : 'left-1'}`} data-id="element-176" />
                </button>
              </div>

              {outline && <input type="range" min="0" max="10" value={outlineWidth} onChange={e => setOutlineWidth(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-violet-600 mt-2" data-id="element-177" />}
            </div>

            <div className="flex gap-2 pt-4" data-id="element-178">
              <PrimaryButtonGreen className="flex-1" data-id="element-179">Apply</PrimaryButtonGreen>
              <button className="p-2 text-red-600 border border-red-200 rounded-lg hover:bg-red-50" data-id="element-180">
                <Trash2 size={20} data-id="element-181" />
              </button>
            </div>
          </div>}

        {/* Layers List */}
        {hasText && <div className="border-t border-gray-100 pt-4" data-id="element-182">
            <h3 className="text-xs font-semibold text-gray-500 uppercase mb-2" data-id="element-183">
              Layers
            </h3>
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg border border-gray-100" data-id="element-184">
              <span className="text-sm font-medium text-gray-700" data-id="element-185">
                Your Text Here
              </span>
              <div className="flex items-center gap-2 text-gray-400" data-id="element-186">
                <button className="hover:text-gray-600" data-id="element-187">
                  <Eye size={14} data-id="element-188" />
                </button>
                <button className="hover:text-gray-600" data-id="element-189">
                  <Lock size={14} data-id="element-190" />
                </button>
                <button className="hover:text-red-600" onClick={() => setHasText(false)} data-id="element-191">
                  <Trash2 size={14} data-id="element-192" />
                </button>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}